import {connect} from "react-redux";
import {Component} from "react";
import * as React from "react";
import DocumentTitle from "react-document-title";

/**
 * Nadstavba komponenty DocumentTitle pro zobrazení prefixu před názvy stránek.
 */
class Title extends Component {

    static PREFIX = "PlanOnline - ";

    render() {
        const {title, children} = this.props;
        return <DocumentTitle title={`${Title.PREFIX}${title}`}>
            {children}
        </DocumentTitle>;
    }
}

export default connect()(Title);
